import React from 'react'
import {Box, Typography} from '@material-ui/core'
import MuiExpansionPanel from '@material-ui/core/Accordion'
import MuiExpansionPanelSummary from '@material-ui/core/AccordionSummary'
import MuiExpansionPanelDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import {withStyles, makeStyles} from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    paper: {
        position: 'absolute',
        top: 48,
        right: 40,
        borderRadius: '0px',
        width: '460px',
        maxHeight: '80vh',
        overflow: 'auto',
        whiteSpace: 'normal',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '320px',
            maxHeight: '75vh',
            right: 0,
        },
    },
    circle: {
        boxSizing: 'border-box',
        borderRadius: '50%',
        backgroundColor: theme.palette.common.white,
        height: '38px',
        width: '38px',
        padding: '1px 1px 1px 1px',
        '&:hover': {
            opacity: 0.8,
            backgroundColor: theme.palette.common.white,
            transition: 'border-color 0.2s, border-width 0.2s',
        },
    },
    helpsubheader: {
        fontWeight: theme.typography.body1.bold.fontWeight,
    },
    text: {
        alignItems: 'flex-start',
        font: 'Regular 0.8125rem/1.1875rem Montserrat',
        letterSpacing: 0,
        color: '#262626',
        opacity: 1,
    },
}))

const ExpansionPanel = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiExpansionPanel)

const ExpansionPanelSummary = withStyles(theme => ({
    root: {
        backgroundColor: theme.palette.common.white,
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: '3.5rem',
        '&$expanded': {
            backgroundColor: theme.palette.grey.pale,
            minHeight: '3.5rem',
        },
    },
    content: {
        '&$expanded': {
            margin: '0.75rem 0',
        },
    },
    expanded: {},
}))(MuiExpansionPanelSummary)

const ExpansionPanelDetails = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiExpansionPanelDetails)

const HelpContentEveryone = props => {
    const classes = useStyles()

    const {expanded, handleChange} = props

    return (
        <>
            <ExpansionPanel
                square
                expanded={expanded === 'panel1'}
                onChange={handleChange('panel1')}
            >
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Typography variant="subtitle1">How to Swipe</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}
                    >
                        <div className={classes.text}>
                            <ol>
                                <li>
                                    Select the event you are swiping for from
                                    the menu on the left. The event you select
                                    will display on the right to begin swiping.
                                </li>
                                <li>
                                    To open/close the event drawer, select the
                                    arrow at top right corner of the drawer.
                                </li>
                                <li>
                                    Make sure you’ve selected the correct event
                                    before you begin swiping.
                                </li>
                            </ol>
                        </div>
                        <Typography
                            variant="body1"
                            align="left"
                            className={classes.helpsubheader}
                        >
                            Record Swipes{' '}
                        </Typography>
                        <div className={classes.text}>
                            <ul>
                                <li>Swipe a card in the card reader.</li>
                                <li>
                                    Type in an EUID and hit submit. An EUID is
                                    what you use to log in on most UNT sites
                                    such as Canvas. (Example: abc1234)
                                </li>
                                <li>
                                    Type in an ID number and hit submit.
                                    (Example: 12345678)
                                </li>
                                <li>
                                    Click the lookup button to start a search by
                                    name.
                                </li>
                            </ul>
                        </div>
                        <Typography variant="body2" align="left">
                            A message will appear at the bottom of your screen
                            informing you of whether or not the swipe was
                            recorded. Successful swipes will cause the swipe
                            count to increase.
                        </Typography>
                    </Box>
                </ExpansionPanelDetails>
            </ExpansionPanel>
            <ExpansionPanel
                square
                expanded={expanded === 'panel2'}
                onChange={handleChange('panel2')}
            >
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                >
                    <Typography variant="subtitle1">
                        How to Lookup by Name
                    </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}
                    >
                        <div className={classes.text}>
                            <ol>
                                <li>Click the “Lookup” button. </li>
                                <li>
                                    Type in the attendees’ first and last name
                                    and click search.
                                </li>
                                <li>
                                    If multiple matches are found, select the
                                    correct person by email.
                                </li>
                                <li>
                                    You can narrow a search by asking for the
                                    attendee’s birth month and day, but don’t
                                    ask for their birth year.
                                </li>
                            </ol>
                        </div>
                    </Box>
                </ExpansionPanelDetails>
            </ExpansionPanel>
            <ExpansionPanel
                square
                expanded={expanded === 'panel3'}
                onChange={handleChange('panel3')}
            >
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                >
                    <Typography variant="subtitle1">Swiping FAQ</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}
                    >
                        <Typography
                            variant="body1"
                            align="left"
                            className={classes.helpsubheader}
                        >
                            Why is my list of events and services empty?
                        </Typography>
                        <Typography variant="body2" align="left" paragraph>
                            You haven’t been added as a swiper to any events or
                            services that are active on the current date. Check
                            with your department’s event creator.
                        </Typography>

                        <Typography
                            variant="body1"
                            align="left"
                            className={classes.helpsubheader}
                        >
                            How do I switch between events and services?
                        </Typography>
                        <Typography variant="body2" align="left" paragraph>
                            Select a different event or service from the menu on
                            the left.
                        </Typography>

                        <Typography
                            variant="body1"
                            align="left"
                            className={classes.helpsubheader}
                        >
                            Why did an attendee get denied?
                        </Typography>
                        <Typography variant="body2" align="left" paragraph>
                            The message that appears after a swipe will tell you
                            specifically why the attendee was denied or inform
                            you of an error so you can try again. Students that
                            are on break or in-between enrollment sessions will
                            get denied at events or services set to “students
                            only.”
                        </Typography>

                        <Typography
                            variant="body1"
                            align="left"
                            className={classes.helpsubheader}
                        >
                            Why isn’t my card reader working?
                        </Typography>
                        <div className={classes.text}>
                            <ul>
                                <li>Select the text box before swiping.</li>
                                <li>
                                    Try flipping the card in the other
                                    direction.
                                </li>
                                <li>
                                    Make sure the card reader is fully plugged
                                    in.
                                </li>
                                <li>
                                    If the card reader is new, it’s possible it
                                    hasn’t been programmed yet. Check with your
                                    department’s event creator.
                                </li>
                            </ul>
                        </div>

                        <Typography
                            variant="body1"
                            align="left"
                            className={classes.helpsubheader}
                        >
                            I don’t see an event drawer!
                        </Typography>
                        <Typography variant="body2" align="left" paragraph>
                            Don’t worry, it’s probably closed! Click the green
                            arrow tab on the left to open it.
                        </Typography>
                    </Box>
                </ExpansionPanelDetails>
            </ExpansionPanel>
        </>
    )
}

export default HelpContentEveryone
